<app-navbar
  #navbarRef
  [footerBarMode]="currentFooterMode"
  (navbarButtonClick)="onNavbarBtnClick($event)"
  (footermodeChange)="onFootermodeChanged($event)">
</app-navbar>

<div [@cardFeedAnimation]="currentAnimationState" class="store-page" ngClass.lt-sm="store-page-lt-sm" ngClass.lt-md="store-page-lt-md" ngClass.gt-sm="store-page-gt-sm" ngClass.gt-lg="store-page-gt-lg">
  <div class="search-input-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
    <h1 class="library-title">Home</h1>
    <button class="additional-navigation-button" (click)="onTopNavAdditionalMenuBtnClicked()">
      <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="14" r="1.5" fill="#828282"/>
        <circle cx="14" cy="14" r="1.5" fill="#828282"/>
        <circle cx="19.1426" cy="14" r="1.5" fill="#828282"/>
        <circle cx="14" cy="14" r="10.125" stroke="#828282" stroke-width="1.75"/>
      </svg>
    </button>
  </div>

  <div class="nodata-wrapper" *ngIf="isNoDataRecieved">
    <h1 class="nodata-title">Something went wrong :(</h1>
    <h3 class="nodata-desc">{{errorData}}</h3>
  </div>

  <div class="store-gallery-overlay" *ngIf="!isNoDataRecieved">
    <app-thumbnail-gallery
      class="no-title zero-margin last-slider-no-switch-panel"
      [sourceCards]="collectionDetailsSource?.collectionCards || []" [sortField]="'modifiedDate'"
      (cardClicked)="onStoreThumbClicked($event)">
    </app-thumbnail-gallery>
  </div>

  <div [@homeOverscrollAnimation]="isModelFeedShown" class="store-overscroll-background" *ngIf="isModelFeedShown"></div>

  <app-models-card
    @modelFeedAnimation
    #modelCardsFeed
    class="feed-overlap model-feed"
    *ngIf="isModelFeedShown"
    [feedMode]="CARDS_MODE.COMPOSITE_FEED"
    [feedModificator]="storeFeedModificator"
    [startPosition]="modelFeedCardStartPosition"
    [feedIsVisible]="isModelFeedShown"
    [cardsRaw]="modelFeedCards"
    (actionBtnClicked)="onCardCollectionControlBtnClicked($event)">
  </app-models-card>

  <app-navpanel
    *ngIf="isNavpanelShown"
    [@navpanelAnimation]="navpanelAnimationState"
    (@navpanelAnimation.done)="onNavpanelAnimationDone($event)"
    [navpanelActionItems]="storeNavpanelItems"
    (hideNavpanelEvent)="onHideNavpanelEventEmitted()"
    (navpanelActionClickEvent)="onNavpanelActionItemClicked($event)"
    (navpanelDestroyEvent)="onNavpanelDestroy()">
  </app-navpanel>
</div>

<app-card-publish-panel
  [@fullscreenPanelAnimation]
  *ngIf="isCardPublishShown"
  [title]="'Select model.'"
  [cardsToSelect]="cardSelectData"
  [userSelectedCards]="[]"
  (cardSelected)="onPublishBulkSelected($event)">
</app-card-publish-panel>
